var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIconBathroom = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.154 5.54V1.885a1.385 1.385 0 1 1 2.77 0v.482M17.538 14.5v-1.866M6.461 14.5v-1.866M0 5.634h24",
  stroke: "currentColor",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m22.468 5.54-2.431 5.593a2.494 2.494 0 0 1-2.288 1.5H6.251c-.993 0-1.892-.589-2.288-1.5L1.533 5.54",
  stroke: "currentColor",
  strokeLinejoin: "round"
})));

export default SvgIconBathroom;